/* eslint-disable import/prefer-default-export */

import moment from 'moment';

/**
 *
 */
export const getDataFilesCacheVersion = (file) => {
    const base64filename = btoa(file);
    let version = localStorage.getItem(base64filename);

    // Set initial value if it does not yet exist
    if (!version) {
        version = moment().unix();
        localStorage.setItem(base64filename, version);
    }

    // Version the file cache if it is more than 5 minutes old
    const elapsedDuration = moment.duration(moment().diff(moment.unix(version)));

    if (elapsedDuration.asMinutes() >= 5) {
        version = moment().unix();
        localStorage.setItem(base64filename, version);
    }

    return `${file}?v=${version}`;
};



// WEBPACK FOOTER //
// ./frontend/helpers/cache.js